import React from 'react';
import styles from './SelectedUserData.module.css';
import moment from 'moment';
import PhoneInput from 'react-phone-input-2';
import { ISelectedUserData } from '../interface/Visitor.interface';
import { tableHeader } from '../../../constants/constants';
import dollar from '../../../images/dollar.png';

export const SelectedUserData = ({ userData }: ISelectedUserData) => {
    return (
        <div className={`${styles.listingContainer}`}>
            <table className="visitorListing">
                <thead>
                    <tr>
                        {tableHeader &&
                            !!tableHeader.length &&
                            tableHeader.map((item, index) => {
                                return <th key={index.toString()}>{item.title}</th>;
                            })}
                    </tr>
                </thead>
                <tbody>
                    {userData?.name !== '' && (
                        <tr>
                            <td>{userData?.name}</td>
                            <td>{userData?.email}</td>
                            <td className={`${styles.noWrap} phone-col`}>
                                <PhoneInput value={String(`+${userData?.countryCode}${userData?.contact}`)} disabled />
                            </td>
                            <td>{userData?.locationName}</td>
                            <td className={styles.noWrap}>
                                {userData?.date && moment(userData?.date).utc().locale('en').format('MM-DD-YYYY')}
                            </td>
                            <td>{userData?.bedrooms === '0' ? 'Studio' : userData?.bedrooms}</td>
                            <td>{userData?.companyName}</td>
                            {/* <td>
                                <img className={styles.editIcon} width={18} height={18} src={dollar} alt="charge" />
                            </td> */}
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
